module.exports = __webpack_public_path__ + "static/media/upload-icon.3e2cdd5d.png";